export interface Anime {
  id: string;
  title: string;
  category: string;
  year: number;
  episodes: number;
  score: number;
  status: "更新中" | "已完结";
  tags: string[];
  desc: string;
  cover: string;
  views: string;
}

export const animeList: Anime[] = [
  {
    id: "xingqiong-zhiren",
    title: "星穹之刃",
    category: "奇幻",
    year: 2025,
    episodes: 24,
    score: 9.4,
    status: "已完结",
    tags: ["冒险", "剑与魔法", "群像"],
    desc: "被遗落在星穹尽头的少年，握起一柄会说话的古刃，踏上横跨九界的救世之旅。宏大世界观与细腻角色成长并行，画面张力十足。",
    views: "328万",
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20key%20visual%20of%20a%20young%20swordsman%20holding%20a%20glowing%20astral%20blade%2C%20cosmic%20nebula%20sky%20with%20floating%20islands%2C%20warm%20amber%20and%20deep%20orange%20palette%2C%20dynamic%20action%20pose%2C%20dramatic%20lighting%2C%20rich%20detail%2C%20cinematic%20composition&width=800&height=450&seq=cover-xingqiong&orientation=landscape",
  },
  {
    id: "nihong-huiyin",
    title: "霓虹回响",
    category: "科幻",
    year: 2025,
    episodes: 12,
    score: 8.9,
    status: "已完结",
    tags: ["赛博朋克", "记忆", "都市"],
    desc: "在雨夜不夜城里，一个能读取他人记忆的拾荒者，意外卷入了一场关于城市起源的阴谋。霓虹与电子乐交织，氛围感极强。",
    views: "196万",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20cyberpunk%20rainy%20night%20city%20with%20neon%20signs%20and%20a%20hooded%20figure%20walking%2C%20reflective%20wet%20streets%2C%20warm%20orange%20and%20magenta%20neon%20glow%2C%20cinematic%20depth%2C%20atmospheric%20fog%2C%20high%20detail%20illustration&width=800&height=450&seq=cover-nihong&orientation=landscape",
  },
  {
    id: "yinghua-fangchengshi",
    title: "樱花方程式",
    category: "恋爱",
    year: 2024,
    episodes: 13,
    score: 8.7,
    status: "已完结",
    tags: ["校园", "青春", "甜蜜"],
    desc: "樱花飘落的春日，转学生与少女在社团教室里重逢。细腻的青春悸动与成长烦恼，交织成一封写给十七岁的情书。",
    views: "214万",
    cover: "https://readdy.ai/api/search-image?query=romantic%20anime%20key%20visual%20of%20cherry%20blossom%20petals%20falling%20over%20a%20school%20courtyard%20with%20two%20students%20under%20a%20tree%2C%20soft%20warm%20sunset%20light%2C%20dreamy%20atmosphere%2C%20delicate%20pastel%20with%20golden%20glow%2C%20detailed%20background%20art&width=800&height=450&seq=cover-yinghua&orientation=landscape",
  },
  {
    id: "wudu-zhentanshe",
    title: "雾都侦探社",
    category: "悬疑",
    year: 2025,
    episodes: 24,
    score: 9.1,
    status: "更新中",
    tags: ["推理", "都市", "案件"],
    desc: "终年笼罩在迷雾中的港城，一家不起眼的侦探社收留了各种奇案。每个案件背后，都藏着一桩关于这座城市的旧事。",
    views: "271万",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20mysterious%20foggy%20harbor%20city%20at%20dusk%20with%20a%20detective%20standing%20before%20an%20old%20office%2C%20amber%20streetlights%20cutting%20through%20mist%2C%20noir%20mood%2C%20warm%20tones%2C%20suspenseful%20atmosphere%2C%20detailed%20illustration&width=800&height=450&seq=cover-wudu&orientation=landscape",
  },
  {
    id: "yuling-shaoniantuan",
    title: "御灵少年团",
    category: "热血",
    year: 2024,
    episodes: 48,
    score: 8.8,
    status: "已完结",
    tags: ["战斗", "伙伴", "成长"],
    desc: "一群少年契约上古灵兽，在学院的竞技场上追逐最强之名。拳拳到肉的战斗与炽热的友情，是青春最燃的注脚。",
    views: "455万",
    cover: "https://readdy.ai/api/search-image?query=energetic%20anime%20key%20visual%20of%20a%20group%20of%20teenagers%20summoning%20spirit%20beasts%20in%20a%20battle%20arena%2C%20fiery%20orange%20energy%20burst%2C%20dynamic%20combat%20motion%2C%20bright%20warm%20lighting%2C%20high%20energy%20composition%2C%20detailed%20character%20art&width=800&height=450&seq=cover-yuling&orientation=landscape",
  },
  {
    id: "yunduan-liaoliwu",
    title: "云端料理屋",
    category: "日常",
    year: 2025,
    episodes: 12,
    score: 9.0,
    status: "更新中",
    tags: ["治愈", "美食", "温情"],
    desc: "漂浮在云端的小料理屋，每晚只接待一位客人。每一道家常料理，都是一段被温柔收藏的心事。慢节奏治愈系佳作。",
    views: "183万",
    cover: "https://readdy.ai/api/search-image?query=cozy%20anime%20key%20visual%20of%20a%20small%20floating%20restaurant%20on%20clouds%20at%20sunset%2C%20steaming%20delicious%20dishes%20on%20a%20wooden%20table%2C%20warm%20golden%20interior%20light%2C%20whimsical%20peaceful%20mood%2C%20soft%20glow%2C%20detailed%20illustration&width=800&height=450&seq=cover-yunduan&orientation=landscape",
  },
  {
    id: "jixie-zhi-xin",
    title: "机械之心",
    category: "科幻",
    year: 2024,
    episodes: 26,
    score: 8.6,
    status: "已完结",
    tags: ["机战", "机甲", "战争"],
    desc: "当人类与机械的界限逐渐模糊，少年驾驶着最后的原型机，在星际战场上寻找属于自己的答案。机设精良，打斗华丽。",
    views: "237万",
    cover: "https://readdy.ai/api/search-image?query=mecha%20anime%20key%20visual%20of%20a%20giant%20robot%20standing%20on%20a%20canyon%20of%20wreckage%20under%20a%20burning%20orange%20sky%2C%20pilot%20silhouette%20in%20foreground%2C%20warm%20embers%20and%20sparks%2C%20epic%20scale%2C%20high%20detail%20mechanical%20design&width=800&height=450&seq=cover-jixie&orientation=landscape",
  },
  {
    id: "yuexia-jian-ge",
    title: "月下剑歌",
    category: "古风",
    year: 2025,
    episodes: 36,
    score: 9.2,
    status: "更新中",
    tags: ["武侠", "江湖", "国风"],
    desc: "一柄佩剑，一段身世。少年自山野踏入乱世江湖，在刀光剑影与爱恨纠葛中，悟出属于自己的剑道。国风美学拉满。",
    views: "512万",
    cover: "https://readdy.ai/api/search-image?query=wuxia%20anime%20key%20visual%20of%20a%20swordsman%20in%20flowing%20robes%20standing%20under%20a%20giant%20full%20moon%20over%20ancient%20roofs%2C%20misty%20mountains%2C%20warm%20moonlight%20and%20orange%20lanterns%2C%20traditional%20chinese%20aesthetic%2C%20elegant%20dynamic%20composition&width=800&height=450&seq=cover-yuexia&orientation=landscape",
  },
  {
    id: "mao-yu-shijian-lvren",
    title: "猫与时间旅人",
    category: "奇幻",
    year: 2024,
    episodes: 13,
    score: 8.9,
    status: "已完结",
    tags: ["治愈", "穿越", "冒险"],
    desc: "一只会说话的白猫，带着迷路的旅人穿梭于时光缝隙之间。每一段旅程都温柔治愈，教会我们与时间和解。",
    views: "168万",
    cover: "https://readdy.ai/api/search-image?query=whimsical%20anime%20key%20visual%20of%20a%20white%20cat%20and%20a%20traveler%20floating%20through%20a%20glowing%20time%20corridor%20of%20floating%20clocks%20and%20stars%2C%20warm%20golden%20and%20orange%20light%2C%20dreamlike%20gentle%20mood%2C%20detailed%20fantasy%20illustration&width=800&height=450&seq=cover-mao&orientation=landscape",
  },
  {
    id: "jiguang-xingjing",
    title: "极光刑警",
    category: "科幻",
    year: 2025,
    episodes: 24,
    score: 8.8,
    status: "更新中",
    tags: ["悬疑", "未来", "动作"],
    desc: "在极地环轨城，一支专门侦破超自然案件的刑警小队，追查着改写现实的异常现象。冷静推理与激烈枪战并存。",
    views: "205万",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20police%20investigator%20team%20under%20a%20glowing%20polar%20aurora%20in%20a%20futuristic%20ring%20city%2C%20teal%20and%20amber%20lights%2C%20snowy%20streets%2C%20tense%20mysterious%20atmosphere%2C%20high%20detail%20sci-fi%20illustration&width=800&height=450&seq=cover-jiguang&orientation=landscape",
  },
  {
    id: "qingchun-chongcixian",
    title: "青春冲刺线",
    category: "运动",
    year: 2024,
    episodes: 26,
    score: 8.5,
    status: "已完结",
    tags: ["体育", "热血", "青春"],
    desc: "田径部的少年们为了一张全国赛门票拼尽全力。冲刺、汗水与呐喊，是夏日操场上最闪亮的光。燃向运动番。",
    views: "154万",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20young%20sprinters%20racing%20across%20a%20sunlit%20school%20track%2C%20motion%20blur%20and%20dust%2C%20golden%20afternoon%20sun%2C%20dynamic%20athletic%20energy%2C%20warm%20orange%20tone%2C%20inspiring%20composition&width=800&height=450&seq=cover-qingchun&orientation=landscape",
  },
  {
    id: "shenyuan-shipu",
    title: "深渊食谱",
    category: "奇幻",
    year: 2025,
    episodes: 12,
    score: 8.7,
    status: "已完结",
    tags: ["美食", "冒险", "黑暗"],
    desc: "地下深渊里栖息着无数奇异生物，也是顶级食材的产地。天才主厨深入深渊，只为烹饪出传说级的深渊盛宴。",
    views: "142万",
    cover: "https://readdy.ai/api/search-image?query=dark%20fantasy%20anime%20key%20visual%20of%20a%20chef%20descending%20into%20a%20glowing%20underworld%20cavern%20with%20luminous%20mushrooms%20and%20rare%20ingredients%2C%20warm%20amber%20bioluminescence%2C%20mysterious%20yet%20appetizing%20mood%2C%20rich%20detail&width=800&height=450&seq=cover-shenyuan&orientation=landscape",
  },
  {
    id: "daihao-zhuque",
    title: "代号：朱雀",
    category: "战斗",
    year: 2026,
    episodes: 12,
    score: 9.3,
    status: "更新中",
    tags: ["动作", "特工", "燃"],
    desc: "神秘特工组织「朱雀」的精英小队，在都市暗战中守护和平。爽快打斗与高能作画，开播即登顶口碑榜。",
    views: "389万",
    cover: "https://readdy.ai/api/search-image?query=action%20anime%20key%20visual%20of%20a%20female%20special%20agent%20in%20a%20leather%20jacket%20amidst%20city%20night%20skyscrapers%2C%20fiery%20phoenix%20energy%20wings%20behind%20her%2C%20warm%20red%20and%20orange%20explosion%20lighting%2C%20dynamic%20cool%20pose%2C%20cinematic%20detail&width=800&height=450&seq=cover-zhuque&orientation=landscape",
  },
  {
    id: "fangxuehou-mofake",
    title: "放学后的魔法课",
    category: "校园",
    year: 2024,
    episodes: 24,
    score: 8.4,
    status: "已完结",
    tags: ["魔法", "搞笑", "轻松"],
    desc: "放学后的魔法社团，天天都在为「如何既瞒过老师又拯救世界」而头秃。轻松搞笑，笑点密集的魔法日常。",
    views: "176万",
    cover: "https://readdy.ai/api/search-image?query=lighthearted%20anime%20key%20visual%20of%20school%20students%20casting%20spells%20in%20a%20sunlit%20classroom%20after%20hours%2C%20sparkling%20magic%20effects%2C%20warm%20golden%20afternoon%20light%2C%20playful%20cheerful%20mood%2C%20bright%20colors%2C%20detailed%20illustration&width=800&height=450&seq=cover-mofa&orientation=landscape",
  },
  {
    id: "yehang-xingtu",
    title: "夜航星图",
    category: "科幻",
    year: 2025,
    episodes: 13,
    score: 8.8,
    status: "已完结",
    tags: ["太空", "冒险", "浪漫"],
    desc: "一艘老旧星舰，一群被遗忘的旅人，在寂静银河中寻找失落的文明坐标。宏大与浪漫交织的太空诗篇。",
    views: "159万",
    cover: "https://readdy.ai/api/search-image?query=space%20anime%20key%20visual%20of%20a%20vintage%20spaceship%20flying%20through%20a%20starry%20nebula%20with%20a%20glowing%20constellation%20map%2C%20warm%20amber%20engine%20glow%20against%20dark%20space%2C%20vast%20romantic%20scale%2C%20high%20detail%20sci-fi%20art&width=800&height=450&seq=cover-yehang&orientation=landscape",
  },
  {
    id: "xiaodao-richang",
    title: "小岛日常",
    category: "日常",
    year: 2024,
    episodes: 12,
    score: 8.6,
    status: "已完结",
    tags: ["搞笑", "治愈", "群像"],
    desc: "在一座与世无争的南方小岛上，渔民、教师与游客们的爆笑日常。没有宏大叙事，只有扑面而来的生活气。",
    views: "121万",
    cover: "https://readdy.ai/api/search-image?query=comedy%20anime%20key%20visual%20of%20a%20sunny%20small%20island%20village%20with%20colorful%20houses%20and%20fishermen%20by%20the%20sea%2C%20bright%20warm%20daylight%2C%20cheerful%20everyday%20mood%2C%20pastel%20and%20golden%20tones%2C%20relaxed%20detailed%20illustration&width=800&height=450&seq=cover-xiaodao&orientation=landscape",
  },
];

export const categories: { name: string; en: string }[] = [
  { name: "热血", en: "re xue" },
  { name: "奇幻", en: "qi huan" },
  { name: "科幻", en: "ke huan" },
  { name: "恋爱", en: "lian ai" },
  { name: "悬疑", en: "xuan yi" },
  { name: "古风", en: "gu feng" },
  { name: "日常", en: "ri chang" },
  { name: "运动", en: "yun dong" },
  { name: "校园", en: "xiao yuan" },
  { name: "战斗", en: "zhan dou" },
];